import { parseUnitString } from '../parse';

/**
 * Checks whether all the component parts of the input (one part if it's a
 * simple unit, multiple if it's compound) are included in the provided set.
 *
 * The unit string is parsed with `preserveName: true`, which means units like
 * "joule" stay as "joule" instead of expanding to base units like
 * "kilogram-meter^2/second^2"; so "joule" will not be allowed just because
 * "kilogram", "meter", and "second" are in the set. This also means that
 * aliases need to be specified in the set: none of them ride along for free.
 *
 * @throws {UnknownUnitError} if the unit string is invalid.
 */
export function doesUnitSetAllowUnitString(
  set: Set<string>,
  unitString: string
): boolean {
  const unit = parseUnitString(unitString, { preserveName: true });
  for (const atomicUnit of unit.keys()) {
    if (!set.has(atomicUnit)) {
      return false;
    }
  }
  return true;
}

/**
 * Returns all the component parts of the input (one part if it's a
 * simple unit, multiple if it's compound) that are not included in the provided set.
 *
 * The unit string is parsed with `preserveName: true`, which means units like
 * "joule" stay as "joule" instead of expanding to base units like
 * "kilogram-meter^2/second^2"; so "joule" will not be allowed just because
 * "kilogram", "meter", and "second" are in the set. This also means that
 * aliases need to be specified in the set: none of them ride along for free.
 *
 * @throws {UnknownUnitError} if the unit string is invalid.
 */
export function getUnitsNotAllowedByUnitSet(
  set: Set<string>,
  unitString: string
): Set<string> {
  const unit = parseUnitString(unitString, { preserveName: true });
  const result = Array.from(unit.keys()).filter(
    (atomicUnit) => !set.has(atomicUnit)
  );
  return new Set(result);
}
